<template>
  <div class="row">
    <div class="col-8 offset-2">
      <Spinner v-if="loading" />
      <DashboardContentBox v-if="!loading" title="Account Activation" subTitle="Complete the following steps to activate your account and access the Synergy ERP">
        <div class="p-4">
          <img src="/glass/img/front-logo.png" class="login-synergy-logo" />
          <FormGroup :form="accountForm">

            <ContentTitle>Welcome to Synergy ERP</ContentTitle>
            <p>Please enter the following details to complete account activation and access your account</p>
            <br />

            <ContentTitle>Owner User Login</ContentTitle>

            <FormRow label="Account">
              <FormStaticLabel>{{profileCompanyName}}</FormStaticLabel>
            </FormRow>
            <FormRow label="User">
              <FormStaticLabel>{{profileUser.email}}</FormStaticLabel>
            </FormRow>
            <FormRow label="Password">
              <FormInputText type="password" v-model="setup.userPassword" placeholder="Password" field="userPassword"></FormInputText>
            </FormRow>
            <FormRow label="Confirm Password">
              <FormInputText type="password" v-model="setup.userConfirmPassword" placeholder="Confirm Password" field="userConfirmPassword"></FormInputText>
            </FormRow>

            <FormHorizontalRule />

            <ContentTitle>Subscription Details</ContentTitle>

            <FormRow label="Subscription">
              <FormStaticLabel>
                <p v-if="activeSubscription && activeSubscriptionItem">
                  <strong>{{activeSubscriptionItem.name}}</strong><br />
                  <span v-if="activeSubscription.isTrialModeActive">Trial period is available until <strong>{{formatDate(activeSubscription.expiryDate)}}</strong><br /></span>
                  <span v-if="activeSubscription.monthlyFee > 0">Monthly Fee : <strong>{{formatCurrency(activeSubscription.monthlyFee)}}</strong><br /></span>
                </p>
                <p v-if="!activeSubscription || !activeSubscriptionItem">Subscription Details Unavailable</p>
              </FormStaticLabel>
            </FormRow>

            <FormRow label="Terms & Conditions">
              <FormCheckbox v-model="setup.agreeTerms" />
              <p>I agree to the <router-link to="/about/terms" target="_blank">SaaS Terms and Conditions</router-link> to use the Synergy System</p>
            </FormRow>

            <FormRow>
              <FormButton class="btn-primary btn-lg" :disabled="!isSubmitEnabled" @click="completeSetup" :loading="submitting">Activate</FormButton>
            </FormRow>

          </FormGroup>
        </div>        
      </DashboardContentBox>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import moment from 'moment-timezone'

import formMixin from '@/mixins/form'
import WizardBox from '@/components/wizardBox'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'

export default {
  name: 'DashboardAccountActivate',
  components: {
    WizardBox,
    DashboardContentBox
  },
  mixins: [formMixin],
  data() {
    return {
      loading: false,
      submitting: false,
      accountForm: {},
      profileData: {},
      accountData: {},
      billingData: {},

      setup: {
        createDefaultUserGroups: true,
        createDefaultGlassConfig: true,
        createDefaultStockCategories: true,
        createDefaultSystemStock: true,
        createDefaultGlassStock: true,
        createDefaultGlassServiceStock: true,
        createDefaultGeneralStock: true,

        userPassword: '',
        userPasswordConfirm: '',

        agreeTerms: false
      },
    }
  },
  computed: {
    ...mapState({
      profileCompanyName: state => state.profile.profileCompanyName,
      profileUser: state => state.profile.profileUser,
    }),
    isSubmitEnabled() {
      return this.setup.agreeTerms
    },
    activeSubscription() {
      if(!this.billingData.subscriptionList)
        return detailsOutput

      return this.billingData.subscriptionList.find(sub => sub.isActive && _.isArray(sub.subscriptionItems) && sub.subscriptionItems.length > 0)      
    },
    activeSubscriptionItem() {
      var activeSub = this.activeSubscription
      if(!activeSub)
        return null

      return activeSub.subscriptionItems.find(subItem => !subItem.isAddonProduct)
    },
    subscriptionDetails() {
      var detailsOutput = 'Subscription Details Unavailable'

      if(!this.billingData.subscriptionList)
        return detailsOutput

      var activeSub = this.billingData.subscriptionList.find(sub => sub.isActive && _.isArray(sub.subscriptionItems) && sub.subscriptionItems.length > 0)
      if(!activeSub)
        return detailsOutput
      var subItem = activeSub.subscriptionItems.find(subItem => !subItem.isAddonProduct)
      if(!subItem)
        return detailsOutput

      detailsOutput = `${subItem.name}`
      if(activeSub.isTrialModeActive) {
        detailsOutput += ` - Trial until ${this.formatDate(activeSub.expiryDate)}`
      }
      if(activeSub.monthlyFee > 0) {
        detailsOutput += `<br />Monthly Fee ${this.formatCurrency(activeSub.monthlyFee)}`
      }

      return detailsOutput
    }
  },
  mounted() {
    // Get billing info
    this.loading = true

    Promise.all([
      this.$api.get('/profile'),
      this.$apiService.adminService.getAccount(),
      this.$apiService.adminService.getAccountBilling()
    ])
    .then(results => {
      this.profileData = results[0].data
      this.accountData = results[1].data
      this.billingData = results[2].data

      this.loading = false
    })
    .catch(err => {
      this.displayNetworkError(err, 'Error accessing data')
    })
  },
  methods: {
    completeSetup() {
      var accountActivationData = {
        userPassword: this.setup.userPassword,
        userConfirmPassword: this.setup.userConfirmPassword,

        createDefaultUserGroups: this.setup.createDefaultUserGroups,
        createDefaultGlassConfig: this.setup.createDefaultGlassConfig,
        createDefaultStockCategories: this.setup.createDefaultStockCategories,
        createDefaultSystemStock: this.setup.createDefaultSystemStock,
        createDefaultGlassStock: this.setup.createDefaultGlassStock,
        createDefaultGlassServiceStock: this.setup.createDefaultGlassServiceStock,
        createDefaultGeneralStock: this.setup.createDefaultGeneralStock,
      }

      this.submitting = true
      this.$apiService.adminService.activateAccount(accountActivationData)
      .then(response => {
        this.$emit('accountUpdated')
      })
      .catch(err => {
        this.$data.accountForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>